import { useState } from "react";

export default function CardCamisa({ camisa, onClick }) {
  const [loaded, setLoaded] = useState(false);

  const handleClick = () => {
    if (!onClick) return;
    onClick(camisa);
  };

  return (
    <div className="card" onClick={handleClick}>
      <img
        src={camisa.imagens[0]}
        alt={camisa.nome}
        loading="lazy"
        className={`card-img ${loaded ? "loaded" : "loading"}`}
        onLoad={() => setLoaded(true)}
      />

      <h3>{camisa.nome}</h3>
    </div>
  );
}
